const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:3001";

function getStoredToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("access_token") ||
    ""
  );
}

async function brandingRequest(path, options = {}) {
  const token = getStoredToken();

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");

    if (window.location.pathname !== "/login") {
      window.location.replace("/login?reason=session-expired");
    }

    throw new Error("Your session expired. Please sign in again.");
  }

  if (!response.ok) {
    const text = await response.text();

    let message = text || `Request failed: ${response.status}`;

    try {
      const parsed = JSON.parse(text);
      message =
        parsed?.detail ||
        parsed?.message ||
        message;
    } catch {
      // Keep the plain-text response.
    }

    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export function getCompanyBranding() {
  return brandingRequest("/company/branding");
}

export function updateCompanyBranding(data) {
  return brandingRequest("/company/branding", {
    method: "PUT",
    body: JSON.stringify(data),
  });
}
